import { render, staticRenderFns } from "./PurchaseCrud.vue?vue&type=template&id=f1da04d0"
import script from "./PurchaseCrud.vue?vue&type=script&lang=js"
export * from "./PurchaseCrud.vue?vue&type=script&lang=js"
import style0 from "./PurchaseCrud.vue?vue&type=style&index=0&id=f1da04d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports